/* eslint-disable */

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { ref, onValue, push } from 'firebase/database';
import { ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";
import { ref as databaseRef } from "firebase/database";
import { db, storage } from '../../../firebase-config';
import { useReactToPrint } from 'react-to-print';
import axios from 'axios';
import html2pdf from 'html2pdf.js';
import "./Combine.css"

const ITEMS_PER_PAGE = 5;

const PrintableReceipt = React.forwardRef(({
    id, doctorData, technicianData, totalViews, totalUploads, totalAmount,
    paymentId, orderId, paymentTimestamp, ctUploads, MriUploads, xrayUploads,
    cpvCosting, cpuCosting, clientGstDetails
}, ref) => {
    const headerContainerStyles = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '20px',
        borderBottom: '8px solid transparent', // Set border color to transparent
        background: 'linear-gradient(to right, #436850 50%, black 50%)', // Gradient from green to black
        backgroundSize: '100% 8px', // The size of the gradient background (full width and 8px height)
        backgroundRepeat: 'no-repeat', // Prevent the gradient background from repeating
        backgroundPosition: 'bottom', // Position the background at the bottom of the element
        marginBottom: '20px',
        marginLeft: '15px',
        marginRight: '15px'
    };


    const logoAndNameContainerStyles = {
        display: 'flex',
        alignItems: 'center',
    };

    const logoStyles = {
        height: 'auto', // Adjust height automatically to maintain aspect ratio
        width: '48px', // Adjust to the desired size
    };

    const companyNameStyles = {
        color: '#436850', // Green color for company name
        fontWeight: 'bold',
        fontSize: '60px',
        marginLeft: '10px', // Space between logo and company name
    };

    const taglineStyles = {
        fontSize: '36px',
        fontWeight: 'bold',
        color: '#000', // Black color for tagline
        marginTop: '5px', // Space between the logo/name and the tagline
    };

    const contactDetailsStyles = {
        textAlign: 'right',
        color: '#000', // Black color for contact details
        fontSize: '16px',
    };

    const boldDetailStyles = {
        fontWeight: 'bold',
    };


    const usageSectionStyles = {
        margin: '0 80px', // Adds left and right margins to the usage section
        paddingBottom: '10px',
    };

    const transactionDetailContainerStyles = {
        padding: '10px',
        backgroundColor: '#ffffff', // White background for the transaction detail section
        boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.1)', // subtle shadow for depth
        borderRadius: '8px',
        marginBottom: '2px',
    };

    const transactionDetailHeadingStyles = {
        color: '#333', // Darker text for better readability
        borderBottom: '2px solid #436850', // Use brand color for heading underline
        paddingBottom: '3px',
        fontSize: '22px',
        fontWeight: 'bold', // Bold for headings
    };

    const transactionDetailItemStyles = {
        display: 'flex',
        justifyContent: 'flex-start',
    };
    
    const transactionDetailLabelStyles = {
        color: '#555', // Medium contrast for labels
    };
    
    const transactionDetailValueStyles = {
        color: '#000', // Black for important detail text
        fontWeight: 'bold',
    };
    

    const gstSectionStyles = {
        padding: '10px',
        backgroundColor: '#ffffff', // White background for the transaction detail section
        boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.1)', // subtle shadow for depth
        borderRadius: '8px',
        marginBottom: '10px',
    };

    const gstDetailStyles = {
        marginBottom: '3px',
        fontSize: '16px',
    };

    const gstDetailTableStyles = {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '6px',
    };

    const gstDetailColumnStyles = {
        flex: '1',
        padding: '0 10px',
    };


    const tableContainerStyles = {
        marginTop: '10px',
        padding: '10px',
        backgroundColor: '#ffffff', // White background for the table section
        boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.1)', // subtle shadow for depth
        borderRadius: '8px',
        marginBottom: '15px',
    };

    const tableStyles = {
        width: '100%',
        borderCollapse: 'collapse',
    };

    const thStyles = {
        textAlign: 'left',
        padding: '10px',
        border: '1px solid #436850', // Use brand color for heading underline
        fontSize: '18px',
        fontWeight: 'bold',
    };

    const tdStyles = {
        padding: '10px',
        border: '1px solid #ddd',
        fontSize: '16px',
    };


    const paymentDate = paymentTimestamp ?
        new Date(paymentTimestamp).toLocaleDateString('en-GB') + ', ' +
        new Date(paymentTimestamp).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true })
        : '';

    const totalAmountExcludingGst = cpvCosting + cpuCosting;
    const gstAmount = totalAmountExcludingGst * 0.18;
    const totalAmountIncludingGst = totalAmountExcludingGst + gstAmount;

    return (
        <div id="printableReceipt" className='receipt-container' ref={ref} style={{ fontFamily: 'Arial, sans-serif' }}>
            {/* Header Section */}
            <div style={headerContainerStyles}>
                <div>
                    <div style={logoAndNameContainerStyles}>
                        <img src="/easiofy.png" alt="Easiofy Logo" style={logoStyles} />
                        <span style={companyNameStyles}>EASIOFY</span>
                    </div>
                    <div style={taglineStyles}>Easiofy Solutions Pvt Ltd</div>
                </div>
                <div style={contactDetailsStyles}>
                    <div style={boldDetailStyles}>
                        I 1607, AVJ heights, sector <br /> zeta1, Greater Noida 201307
                        <i className="fas fa-map-marker-alt" style={{ marginLeft: '5px' }}></i>
                    </div>
                    <div>
                        +91 99584 99337
                        <i className="fas fa-phone" style={{ marginLeft: '5px' }}></i>
                    </div>
                    <div>
                        noor.fatma@easiofy.com
                        <i className="fas fa-envelope" style={{ marginLeft: '5px' }}></i>
                    </div>
                    <div>
                        <a href="https://easiofy.com/" style={{ textDecoration: 'none', color: '#333' }}>
                            https://easiofy.com/
                        </a>
                        <i className="fas fa-globe" style={{ marginLeft: '5px' }}></i>
                    </div>
                </div>
            </div>

            {/* Title and Transaction Section */}
            <div style={usageSectionStyles}>
                <h2 style={{ textAlign: 'center', fontSize: '30px', fontWeight: 'bold', marginBottom: '10px', textTransform: 'uppercase' }}>
                    {`Payment Receipt`}
                </h2>



                <div style={gstSectionStyles}>
                    <h5 style={transactionDetailHeadingStyles}>GST Details</h5>
                    <div style={gstDetailTableStyles}>
                        <div style={gstDetailColumnStyles}>
                            <strong>From:</strong>
                            <div style={gstDetailStyles}>
                                Easiofy Solutions Pvt Ltd.
                            </div>
                            <div style={gstDetailStyles}>
                                <strong>GSTIN: </strong>09AAHCE2212N1ZK
                            </div>
                            <div style={gstDetailStyles}>
                                <strong>Company's Address: </strong>I 1607, AVJ Heights, Sector Zeta1, Greater Noida - 201307.
                            </div>
                        </div>
                        <div style={gstDetailColumnStyles}>
                            <strong>Bill to: </strong>
                            <div style={gstDetailStyles}>
                                <strong>Client Name: </strong>{clientGstDetails.companyName}
                            </div>
                            <div style={gstDetailStyles}>
                                <strong>Client GSTIN: </strong>{clientGstDetails.gstin}
                            </div>
                            <div style={gstDetailStyles}>
                                <strong>Client's Address: </strong>{clientGstDetails.address}
                            </div>
                        </div>
                    </div>
                </div>


                <div style={transactionDetailContainerStyles}>
                    <h3 style={transactionDetailHeadingStyles}>Transaction Details</h3>
                    <div>
                        <div style={transactionDetailItemStyles}>
                            <span style={transactionDetailLabelStyles}>Payment ID : </span>
                            <span style={transactionDetailValueStyles}>{paymentId}</span>
                        </div>
                        <div style={transactionDetailItemStyles}>
                            <span style={transactionDetailLabelStyles}>Order ID : </span>
                            <span style={transactionDetailValueStyles}>{orderId}</span>
                        </div>
                        <div style={transactionDetailItemStyles}>
                            <span style={transactionDetailLabelStyles}>Date : </span>
                            <span style={transactionDetailValueStyles}>{paymentDate}</span>
                        </div>
                    </div>
                </div>

                {/* New Table Section */}
                <div style={tableContainerStyles}>
                    <table style={tableStyles}>
                        <thead>
                            <tr>
                                <th style={thStyles}>Description</th>
                                <th style={thStyles}>Count</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={tdStyles}>Total Views</td>
                                <td style={tdStyles}>{totalViews}</td>
                            </tr>
                            <tr>
                                <td style={tdStyles}>Total Uploads (MRI: {MriUploads},CT: {ctUploads},XRAY: {xrayUploads})</td>
                                <td style={tdStyles}>{totalUploads}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className='total-amount'>
                    <div>Amount</div>
                    <div>{totalAmountExcludingGst}₹</div>
                </div>

                <div className='total-amount'>
                    <div>IGST (18%)</div>
                    <div>{gstAmount}₹</div>
                </div>

                <div className='total-amount'>
                    <div>Total Amount Paid</div>
                    <div>{totalAmountIncludingGst}₹</div>
                </div>
            </div>
        </div>
    );
});


const PrintableBillingDetails = React.forwardRef(({
    id, doctorData, technicianData, totalViews, totalUploads, totalAmount, ctUploads, MriUploads, xrayUploads, cpuCosting, cpvCosting
}, ref) => {
    const headerContainerStyles = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '20px',
        borderBottom: '8px solid transparent',
        background: 'linear-gradient(to right, #436850 50%, black 50%)',
        backgroundSize: '100% 8px',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'bottom',
        marginBottom: '20px',
        width: '100%'
    };

    const contentStyles = {
        margin: '0 auto',
        maxWidth: '960px',
        width: '100%',
    };

    const logoAndNameContainerStyles = {
        display: 'flex',
        alignItems: 'center',
    };

    const logoStyles = {
        height: 'auto',
        width: '48px',
    };

    const companyNameStyles = {
        color: '#436850',
        fontWeight: 'bold',
        fontSize: '60px',
        marginLeft: '10px',
    };

    const taglineStyles = {
        fontSize: '36px',
        fontWeight: 'bold',
        color: '#000',
        marginTop: '5px',
    };

    const contactDetailsStyles = {
        textAlign: 'right',
        color: '#000',
        fontSize: '16px',
    };

    const boldDetailStyles = {
        fontWeight: 'bold',
    };

    return (
        <div className='billing-container printing-div' ref={ref}>
            <div style={headerContainerStyles}>
                <div>
                    <div style={logoAndNameContainerStyles}>
                        <img src="/easiofy.png" alt="Easiofy Logo" style={logoStyles} />
                        <span style={companyNameStyles}>EASIOFY</span>
                    </div>
                    <div style={taglineStyles}>Easiofy Solutions Pvt Ltd</div>
                </div>
                <div style={contactDetailsStyles}>
                    <div style={boldDetailStyles}>
                        I 1607, AVJ heights, sector <br /> zeta1, Greater Noida 201307
                        <span role="img" aria-label="Location">📍</span>
                    </div>
                    <div>
                        +91 99584 99337
                        <span role="img" aria-label="Phone">📞</span>
                    </div>
                    <div>
                        noor.fatma@easiofy.com
                        <span role="img" aria-label="Email">📧</span>
                    </div>
                    <div>
                        <a href="https://easiofy.com/" style={{ textDecoration: 'none', color: '#333' }}>
                            https://easiofy.com/
                        </a>
                        <span role="img" aria-label="Website">💻</span>
                    </div>
                </div>
            </div>

            <div style={contentStyles}>
                <h2 style={{ marginBottom: "30px", marginTop: "20px" }} className='BillingAdminName'>{`Billing Details for ${id}`}</h2>
                <table className="Billing-table">
                    <thead>
                        <tr>
                            <th className="billing-heading">Viewed by Doctor</th>
                            <th className="billing-heading">View Count</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.entries(doctorData).map(([doctorNameOrUID, { viewCount }]) => (
                            <tr key={doctorNameOrUID}>
                                <td>{doctorNameOrUID}</td>
                                <td style={{ textAlign: 'center' }}>{viewCount}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <div className="total-views-container">
                    <h6>Total Views: {totalViews}</h6>
                    <h6 className="viewing-cost">Viewing Cost : ₹{cpvCosting}</h6>
                </div>

                <table className="Billing-table">
                    <thead>
                        <tr>
                            <th className="billing-heading">Uploaded by Technician</th>
                            <th className="billing-heading" style={{ textAlign: 'center' }}>Upload Count</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.entries(technicianData).map(([technicianNameOrUID, { viewCount }]) => (
                            <tr key={technicianNameOrUID}>
                                <td>{technicianNameOrUID}</td>
                                <td style={{ textAlign: 'center' }}>{viewCount}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <div className="total-uploads-container">
                    <h6>Total Uploads: {totalUploads}</h6>
                    <h6 className="uploading-cost">Uploading Cost : ₹{cpuCosting}</h6>
                </div>

                <div className="upload-details">
                    <h6>CT: {ctUploads}</h6>
                    <h6>MRI: {MriUploads}</h6>
                    <h6>X-ray: {xrayUploads}</h6>
                </div>

                <div className='total-amount'>
                    <div>Total Amount to Pay</div>
                    <div>{`₹${totalAmount}`}</div>
                </div>
            </div>
        </div>
    );
});

function CombinedBilling({ id: propId }) {
    const { id: paramsId } = useParams();
    const id = paramsId || propId;
    const [currentPage, setCurrentPage] = useState(1);
    const [printableVisible, setPrintableVisible] = useState(false);
    const componentRef = React.useRef();
    const [showPatientInfo, setShowPatientInfo] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [isLoaderPaymentInitialized, setIsLoaderPaymentInitialized] = useState(false);
    const receiptRef = React.useRef();
    const [receiptVisible, setReceiptVisible] = useState(false);
    const [paymentId, setPaymentId] = useState('');
    const [orderId, setOrderId] = useState('');
    const [paymentTimestamp, setPaymentTimestamp] = useState('');
    const [isGeneratingReceipt, setIsGeneratingReceipt] = useState(false);
    const [showCheckmark, setShowCheckmark] = useState(false);
    const [doctorData, setDoctorData] = useState({});
    const [technicianData, setTechnicianData] = useState({});
    const [totalViews, setTotalViews] = useState(0);
    const [totalUploads, setTotalUploads] = useState(0);
    const [cpvCosting, setcpvCosting] = useState(0);
    const [cpuCosting, setcpuCosting] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [AmountExcludingGst, setAmountExcludingGst] = useState(0);
    const [gstAmount, setGstAmount] = useState(0);
    const [AmountIncludingGst, setAmountIncludingGst] = useState(0);
    const [ctUploads, setCtUploads] = useState(0);
    const [MriUploads, setMriUploads] = useState(0);
    const [xrayUploads, setXrayUploads] = useState(0);
    const [fullName, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [isPaymentUpToDate, setIsPaymentUpToDate] = useState(false); // new state
    const [clientGstDetails, setClientGstDetails] = useState({
        companyName: '',
        gstin: '',
        address: ''
    });
    const [isGstDetailsValid, setIsGstDetailsValid] = useState(false);

    const navigate = useNavigate();


    // Effect that triggers PDF generation when payment details are set
    useEffect(() => {
        // Check if all payment details are available
        if (orderId && paymentId && paymentTimestamp) {
            generatePDFandSave(orderId, paymentId, id,);
        }
    }, [orderId, paymentId, paymentTimestamp, id]);

    useEffect(() => {
        // Check if GST details are filled
        const { companyName, gstin, address } = clientGstDetails;
        setIsGstDetailsValid(companyName.trim() !== '' && gstin.trim() !== '' && address.trim() !== '');
    }, [clientGstDetails]);


    useEffect(() => {
        const fetchBillingData = async () => {
            try {
                const billingRef = ref(db, `superadmin/admins/${id}/costing`);
                onValue(billingRef, (snapshot) => {
                    if (snapshot.exists()) {
                        const data = snapshot.val();
                        processBillingData(data);
                    } else {
                        setIsLoading(false);
                    }
                });

                const userDetailsRef = ref(db, `superadmin/admins/${id}`);
                onValue(userDetailsRef, (snapshot) => {
                    if (snapshot.exists()) {
                        const data = snapshot.val();
                        setFullName(data.FullName || '');
                        setEmail(data.Email || '');
                    } else {
                        console.log('No data available');
                    }
                    setIsLoading(false);
                });
            } catch (error) {
                console.error("Error fetching billing data:", error);
                setIsLoading(false);
            }
        };

        fetchBillingData();
    }, [id]);

    function parseTimeStamp(timeStampStr) {
        try {
            const [datePart, timePart] = timeStampStr.split(', ');
            const [day, month, year] = datePart.split('/');
            const [hours, minutes, seconds] = timePart.split(':');
            return new Date(year, month - 1, day, hours, minutes, seconds);
        } catch (e) {
            return null; // Return null if parsing fails
        }
    }


    useEffect(() => {
        const fetchPaymentStatus = async () => {
            const paymentRef = ref(db, `superadmin/admins/${id}/payment`);
            onValue(paymentRef, (paymentSnapshot) => {
                let latestPaymentTimestamp = null;
                if (paymentSnapshot.exists()) {
                    const payments = paymentSnapshot.val();
                    Object.values(payments).forEach(payment => {
                        const paymentTime = parseTimeStamp(payment.paymentTimestamp);
                        if (paymentTime && (!latestPaymentTimestamp || paymentTime > latestPaymentTimestamp)) {
                            latestPaymentTimestamp = paymentTime;
                        }
                    });
                }

                const costingRef = ref(db, `superadmin/admins/${id}/costing`);
                onValue(costingRef, (costingSnapshot) => {
                    if (costingSnapshot.exists()) {
                        const costingData = costingSnapshot.val();
                        processBillingData(costingData, latestPaymentTimestamp);
                    } else {
                        setIsPaymentUpToDate(true); // Set payment up-to-date when no costing data exists
                        setIsLoading(false);
                    }
                });
            });
        };

        fetchPaymentStatus();
    }, [id]);

    const processBillingData = (data, latestPaymentTimestamp) => {
        const viewData = Object.keys(data.last_Viewed_Events || {}).flatMap(month => {
            const monthEntries = data.last_Viewed_Events[month];
            return Object.keys(monthEntries).map(index => {
                const { doctor, patient, timestamp } = monthEntries[index];
                return { doctor, patient, timestamp };
            }).filter(event => !latestPaymentTimestamp || parseTimeStamp(event.timestamp) > latestPaymentTimestamp);
        });

        const uploadData = Object.keys(data.Upload_Events || {}).flatMap(month => {
            const monthEntries = data.Upload_Events[month];
            return Object.keys(monthEntries).map(index => {
                const { TechnicianName, PatientName, timeStamp, Modality } = monthEntries[index];
                return { TechnicianName, PatientName, timeStamp, Modality };
            }).filter(event => !latestPaymentTimestamp || parseTimeStamp(event.timeStamp) > latestPaymentTimestamp);
        });

        if (viewData.length === 0 && uploadData.length === 0) {
            setIsPaymentUpToDate(true);
            setIsLoading(false);
            return;
        }

        const doctorData = viewData.reduce((accumulator, { doctor, patient, timestamp }) => {
            accumulator[doctor] = accumulator[doctor] || { entries: [], viewCount: 0 };
            accumulator[doctor].entries.push({ patient, timestamp });
            accumulator[doctor].viewCount += 1;
            return accumulator;
        }, {});

        const totalViews = Object.values(doctorData).reduce((acc, { viewCount }) => acc + viewCount, 0);

        const technicianData = uploadData.reduce((accumulator, { TechnicianName, PatientName, timeStamp }) => {
            accumulator[TechnicianName] = accumulator[TechnicianName] || { entries: [], viewCount: 0 };
            accumulator[TechnicianName].entries.push({ PatientName, timeStamp });
            accumulator[TechnicianName].viewCount += 1;
            return accumulator;
        }, {});

        const totalUploads = Object.values(technicianData).reduce((acc, { viewCount }) => acc + viewCount, 0);

        const ctUploads = uploadData.filter(event => event.Modality === 'CT').length;
        const mriUploads = uploadData.filter(event => event.Modality === 'MRI').length;
        const xrayUploads = uploadData.filter(event => event.Modality === 'XRAY').length;

        const CPV = data.CPV || 0;
        const CPU = data.CPU || {};

        const ctCost = ctUploads * (CPU.CTPricing || 0);
        const mriCost = mriUploads * (CPU.MRIPricing || 0);
        const xrayCost = xrayUploads * (CPU.XrayPricing || 0);

        const cpuCost = ctCost + mriCost + xrayCost;
        const cpvCost = totalViews * CPV;

        const totalAmountExcludingGst = cpvCost + cpuCost;
        setAmountExcludingGst(totalAmountExcludingGst);

        const gstAmount = totalAmountExcludingGst * 0.18;
        setGstAmount(gstAmount);
        const totalAmountIncludingGst = totalAmountExcludingGst + gstAmount;
        setAmountIncludingGst(totalAmountIncludingGst);

        setDoctorData(doctorData);
        setTechnicianData(technicianData);
        setTotalViews(totalViews);
        setTotalUploads(totalUploads);
        setTotalAmount(totalAmountIncludingGst); // Set total amount including GST
        setcpvCosting(cpvCost);
        setcpuCosting(cpuCost);

        setCtUploads(ctUploads);
        setMriUploads(mriUploads);
        setXrayUploads(xrayUploads);
        setIsLoading(false);
    };


    const handlePrintReceipt = useReactToPrint({
        content: () => receiptRef.current,
        onAfterPrint: () => setReceiptVisible(false),
    });

    const showReceipt = () => {
        setReceiptVisible(true);
        handlePrintReceipt();
    };

    const printBillingDetails = useReactToPrint({
        content: () => componentRef.current,
        onAfterPrint: () => setPrintableVisible(false),
    });

    const showPrintable = () => {
        setPrintableVisible(true);
        printBillingDetails();
    };

    const goToPreviousPage = () => {
        setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
    };

    const goToNextPage = () => {
        const totalPages = Math.ceil(Math.max(Object.keys(doctorData).length, Object.keys(technicianData).length) / ITEMS_PER_PAGE);
        setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
    };

    const togglePatientInfo = (name) => {
        setShowPatientInfo(prevState => ({
            ...prevState,
            [name]: !prevState[name]
        }));
    };

    if (isLoading) {
        return <div className="spinner-overlay">
            <div className="spinner"></div>
            <p>Please wait...</p>
        </div>;
    }



    // Before returning the main component content, check if the receipt is being generated or if payment is up to date
    if (isGeneratingReceipt) {
        // Return the loading/spinner or checkmark UI
    } else if (isPaymentUpToDate) {
        // Render the success message with centered content and full-page animated background
        return (
            <div className="success-theme">
                <div> {/* Wrapper for text content to align it properly */}
                    <h1>Payments Up to Date &#10003;</h1>
                    <p>Your payments are up to date. You don't have any pending bills.</p>
                    <button
                        className="go-back-btn"
                        onClick={() => navigate("/Admin")}
                    >
                        Go Back
                    </button>
                </div>
            </div>
        );
    }



    const loadRazorpayScript = (src) => new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.body.appendChild(script);
    });

    const handlePayment = async () => {
        if (!isGstDetailsValid) {
            alert('GST details are mandatory. Please fill them out before proceeding.');
            return;
        }
        setIsLoaderPaymentInitialized(true);
        const scriptLoaded = await loadRazorpayScript('https://checkout.razorpay.com/v1/checkout.js');
        if (!scriptLoaded) {
            alert('Failed to load Razorpay SDK. Please check your internet connection.');
            setIsLoaderPaymentInitialized(false);
            return;
        }

        try {
            const orderResponse = await axios.post('https://hqkcxtqdsi.execute-api.us-east-1.amazonaws.com/dev/create-order', {
                amount: AmountIncludingGst * 100,
            });
            const orderData = orderResponse.data;

            const options = {
                key: 'rzp_test_0TrVVCr438tsgd',
                amount: orderData.amount,
                currency: 'INR',
                name: 'Easiofy Solution',
                description: `Bill Payment for ${id}`,
                image: `${window.location.origin}/easiofy.png`,
                order_id: orderData.id,
                prefill: {
                    name: fullName,  // Use fullName from state
                    email: email,  // Use email from state
                },
                theme: {
                    color: '#3399cc',
                },
                handler: async (response) => {
                    setIsLoaderPaymentInitialized(false);
                    const verificationResponse = await axios.post('https://hqkcxtqdsi.execute-api.us-east-1.amazonaws.com/dev/verify-payment', {
                        orderCreationId: response.razorpay_order_id,
                        razorpayPaymentId: response.razorpay_payment_id,
                        razorpaySignature: response.razorpay_signature,
                    });

                    if (verificationResponse.data.valid) {
                        alert('Payment verified successfully');
                        setPaymentId(response.razorpay_payment_id);
                        setOrderId(orderData.id);
                        setPaymentTimestamp(Date.now());
                    } else {
                        alert('Payment verification failed.');
                    }

                    setIsLoaderPaymentInitialized(false);
                },
                modal: {
                    ondismiss: () => {
                        setIsLoaderPaymentInitialized(false);
                    }
                }
            };

            const paymentObject = new window.Razorpay(options);
            paymentObject.open();
        } catch (error) {
            console.error("Error creating order:", error);
            alert('Error creating order. Please try again.');
            setIsLoaderPaymentInitialized(false);
        }
    };

    const generatePDFandSave = async (orderId, paymentId, id) => {
        setIsGeneratingReceipt(true);
        try {
            const element = document.getElementById("printableReceipt");
            const options = {
                margin: [0, 0, 2, 0],
                filename: `Receipt-${orderId}.pdf`,
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
            };

            const blob = await html2pdf().set(options).from(element).toPdf().output('blob');
            const pdfPath = `superadmin/admins/${id}/Payment/Receipt-${orderId}.pdf`;
            const pdfStorageRef = storageRef(storage, pdfPath);
            await uploadBytes(pdfStorageRef, blob);

            const pdfDownloadUrl = await getDownloadURL(pdfStorageRef);

            const formatDateTime = (date) =>
                `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}, ` +
                `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;

            const Timestamp = formatDateTime(new Date());

            const paymentDetailsRef = databaseRef(db, `superadmin/admins/${id}/payment`);
            await push(paymentDetailsRef, {
                orderId,
                paymentId,
                pdfDownloadUrl,
                paymentTimestamp: Timestamp
            });

            console.log('PDF uploaded, payment details saved, and payment details reset.');
        } catch (error) {
            console.error('Error generating or uploading PDF:', error);
        } finally {
            setShowCheckmark(true);

            setTimeout(() => {
                navigate("/Admin");
            }, 3000);
        }
    };



    const doctorEntries = Object.entries(doctorData);
    const technicianEntries = Object.entries(technicianData);

    const totalPages = Math.ceil(Math.max(doctorEntries.length, technicianEntries.length) / ITEMS_PER_PAGE);

    const doctorPageStart = (currentPage - 1) * ITEMS_PER_PAGE;
    const doctorPageEnd = doctorPageStart + ITEMS_PER_PAGE;
    const technicianPageStart = (currentPage - 1) * ITEMS_PER_PAGE;
    const technicianPageEnd = technicianPageStart + ITEMS_PER_PAGE;

    const currentDoctorEntries = doctorEntries.slice(doctorPageStart, doctorPageEnd);
    const currentTechnicianEntries = technicianEntries.slice(technicianPageStart, technicianPageEnd);

    const noMoreDoctorData = currentDoctorEntries.length === 0;
    const noMoreTechnicianData = currentTechnicianEntries.length === 0;

    return (
        <>
            {isLoaderPaymentInitialized && (
                <div className="loader-payment-initialized-container">
                    <div className="loader-payment-initialized">
                        <div className="loader-dot"></div>
                        <div className="loader-dot"></div>
                        <div className="loader-dot"></div>
                        <div className="loader-dot"></div>
                    </div>
                </div>
            )}

            <div className='billing-body'>
                <Link to="/Admin" className="homeButton backbutton-combine billing-backButton">
                    <span id="backText" className="backText">Back</span>
                    <i id="backIcon" className="fas fa-long-arrow-alt-left fa-lg fa-2x"></i>
                </Link>

                {isGeneratingReceipt && (
                    <div className="payment-spinner-overlay">
                        {!showCheckmark ? (
                            <div className="payment-spinner-container">
                                <div className="lds-ripple"><div></div><div></div></div>
                            </div>
                        ) : (
                            <div className="payment-success-container">
                                <div className="payment-success-icon">&#10003;</div>
                            </div>
                        )}
                        <div className="payment-message-container">
                            <h2>{!showCheckmark ? 'Generating Receipt...' : 'Receipt Ready!'}</h2>
                            <h5>You'll be redirected to the homepage shortly.</h5>
                        </div>
                    </div>
                )}

                <div style={{ display: printableVisible ? 'block' : 'none' }}>
                    <PrintableReceipt
                        ref={receiptRef}
                        id={id}
                        doctorData={doctorData}
                        technicianData={technicianData}
                        totalViews={totalViews}
                        totalUploads={totalUploads}
                        totalAmount={totalAmount}
                        paymentId={paymentId}
                        orderId={orderId}
                        paymentTimestamp={paymentTimestamp}
                        ctUploads={ctUploads}
                        MriUploads={MriUploads}
                        xrayUploads={xrayUploads}
                        cpvCosting={cpvCosting}
                        cpuCosting={cpuCosting}
                        clientGstDetails={clientGstDetails}
                    />

                </div>

                <div style={{ display: printableVisible ? 'block' : 'none' }}>
                    <PrintableBillingDetails
                        ref={componentRef}
                        id={id}
                        doctorData={doctorData}
                        technicianData={technicianData}
                        totalViews={totalViews}
                        totalUploads={totalUploads}
                        totalAmount={totalAmount}
                        ctUploads={ctUploads}
                        MriUploads={MriUploads}
                        xrayUploads={xrayUploads}
                        cpvCosting={cpvCosting}
                        cpuCosting={cpuCosting}
                    />
                </div>

                <div className="billing-container">
                    <h2 className='BillingAdminName'>{`Billing Details for ${id}`}</h2>

                    <div className='actions'>
                        <button onClick={showPrintable} className='print-button'>
                            Click to Print
                        </button>
                        <button onClick={showReceipt} className='print-button' style={{ display: 'none' }}>
                            Generate Receipt
                        </button>
                        {/* <button onClick={showReceipt} className='print-button'>
                            Generate Receipt
                        </button> */}
                    </div>

                    <div className="section doctor-section">
                        <h6>Viewing Details :</h6>
                        <table className="Billing-table">
                            <thead>
                                <tr>
                                    <th className="billing-heading">Viewed by Doctor</th>
                                    <th style={{ textAlign: 'center' }} className="billing-heading">View Count</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentDoctorEntries.map(([doctorNameOrUID, { entries }]) => (
                                    <React.Fragment key={doctorNameOrUID}>
                                        <tr className="special-row">
                                            <td>
                                                <button onClick={() => togglePatientInfo(doctorNameOrUID)}>
                                                    {showPatientInfo[doctorNameOrUID] ? '-' : '+'}
                                                </button>
                                                {doctorNameOrUID}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>{entries.length}</td>
                                        </tr>
                                        {showPatientInfo[doctorNameOrUID] && (
                                            <tr>
                                                <td colSpan="2">
                                                    <table className="Billing-table-inner">
                                                        <thead>
                                                            <tr>
                                                                <th>Name of Patient</th>
                                                                <th>Time of Viewing</th>
                                                                <th style={{ textAlign: 'center' }}>Patient View Count</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {Object.entries(entries.reduce((acc, entry) => {
                                                                acc[entry.patient] = acc[entry.patient] || { count: 0, timestamps: [] };
                                                                acc[entry.patient].count++;
                                                                acc[entry.patient].timestamps.push(entry.timestamp);
                                                                return acc;
                                                            }, {})).map(([patient, { count, timestamps }], index) => (
                                                                <tr key={index}>
                                                                    <td>{patient}</td>
                                                                    <td>
                                                                        <select>
                                                                            {timestamps.map((timestamp, index) => (
                                                                                <option key={index}>{timestamp}</option>
                                                                            ))}
                                                                        </select>
                                                                    </td>
                                                                    <td style={{ textAlign: 'center' }}>{count}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>

                        {noMoreDoctorData && <h6>No more doctor data found.</h6>}

                        <div className="total-views-container">
                            <h6>Total Views: {totalViews}</h6>
                            <h6 className="viewing-cost">Viewing Cost : {cpvCosting}₹</h6>
                        </div>

                    </div>

                    <div className="section technician-section">
                        <h6>Uploading Details :</h6>
                        <table className="Billing-table">
                            <thead>
                                <tr>
                                    <th className="billing-heading">Uploaded by Technician</th>
                                    <th className="billing-heading" style={{ textAlign: 'center' }}>Upload Count</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentTechnicianEntries.map(([technicianNameOrUID, { entries }]) => (
                                    <React.Fragment key={technicianNameOrUID}>
                                        <tr className="special-row">
                                            <td>
                                                <button onClick={() => togglePatientInfo(technicianNameOrUID)}>
                                                    {showPatientInfo[technicianNameOrUID] ? '-' : '+'}
                                                </button>
                                                {technicianNameOrUID}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>{entries.length}</td>
                                        </tr>
                                        {showPatientInfo[technicianNameOrUID] && (
                                            <tr>
                                                <td colSpan="2">
                                                    <table className="Billing-table-inner">
                                                        <thead>
                                                            <tr>
                                                                <th>Name of Patient</th>
                                                                <th>Time of Upload</th>
                                                                <th style={{ textAlign: 'center' }}>Patient Upload Count</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {Object.entries(entries.reduce((acc, entry) => {
                                                                acc[entry.PatientName] = acc[entry.PatientName] || { count: 0, timestamps: [] };
                                                                acc[entry.PatientName].count++;
                                                                acc[entry.PatientName].timestamps.push(entry.timeStamp);
                                                                return acc;
                                                            }, {})).map(([patient, { count, timestamps }], index) => (
                                                                <tr key={index}>
                                                                    <td>{patient}</td>
                                                                    <td>
                                                                        <select>
                                                                            {timestamps.map((timestamp, index) => (
                                                                                <option key={index}>{timestamp}</option>
                                                                            ))}
                                                                        </select>
                                                                    </td>
                                                                    <td style={{ textAlign: 'center' }}>{count}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>

                        {noMoreTechnicianData && <h6>No more technician data found.</h6>}

                        <div className="total-uploads-container">
                            <h6>Total Uploads: {totalUploads}</h6>
                            <h6 className="uploading-cost">Uploading Cost : {cpuCosting}₹</h6>
                        </div>

                        <div className="upload-details">
                            <h6>CT: {ctUploads}</h6>
                            <h6>MRI: {MriUploads}</h6>
                            <h6>X-ray: {xrayUploads}</h6>
                        </div>
                    </div>

                    <div className="gst-details-form">
                        <h5>Enter Your GST Details<span className="required-asterisk">*</span></h5>
                        <span className='GstDetails-Span'>
                            Company Name:
                            <input
                                type="text"
                                value={clientGstDetails.companyName}
                                onChange={(e) => setClientGstDetails({ ...clientGstDetails, companyName: e.target.value })}
                            />
                        </span>
                        <span className='GstDetails-Span'>
                            GSTIN:
                            <input
                                type="text"
                                value={clientGstDetails.gstin}
                                onChange={(e) => setClientGstDetails({ ...clientGstDetails, gstin: e.target.value })}
                            />
                        </span>
                        <span className='GstDetails-Span'>
                            Address:
                            <input
                                type="text"
                                value={clientGstDetails.address}
                                onChange={(e) => setClientGstDetails({ ...clientGstDetails, address: e.target.value })}
                            />
                        </span>
                        {!isGstDetailsValid && <p className="error-message">All GST fields are mandatory.</p>}
                    </div>



                    <div className='total-amount'>
                        <div>Amount (Excluding GST)</div>
                        <div>{AmountExcludingGst}₹</div>
                    </div>

                    <div className='total-amount'>
                        <div>IGST (18%)</div>
                        <div>{gstAmount}₹</div>
                    </div>

                    <div className='total-amount'>
                        <div>Total Amount To Pay</div>
                        <div>{AmountIncludingGst}₹</div>
                    </div>

                    <div style={{ textAlign: 'center' }}>
                        <button onClick={() => handlePayment(AmountIncludingGst)} className="pay-button btn btn-dark btn-lg">Pay Now</button>
                    </div>

                    <div className="pagination-combinecosting">
                        <button onClick={goToPreviousPage} disabled={currentPage === 1}>Previous</button>
                        <span>{`Page ${currentPage} of ${totalPages}`}</span>
                        <button onClick={goToNextPage} disabled={currentPage === totalPages}>Next</button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CombinedBilling;
